import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaArrowLeft } from 'react-icons/fa';
import backgroundImage from '../images/background.jpg';

const Error404Page = () => {
  return (
    <div className="min-h-screen bg-F5F5DC">
      {/* Hero Section */}
      <div
        className="relative bg-cover bg-center h-[40vh] mb-16"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        <div className="absolute inset-0 bg-black opacity-40"></div> {/* Overlay */}
        <div className="container mx-auto max-w-7xl px-4 py-20 relative z-10 text-center text-white">
          <motion.h1
            className="text-6xl font-extrabold"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            404 - Page Not Found
          </motion.h1>
          <motion.p
            className="mt-4 text-lg"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Oops! Looks like this page doesn't exist.
          </motion.p>
        </div>
      </div>

      {/* Main Content */}
      <section className="container mx-auto max-w-6xl px-4 text-center mb-32">
        <motion.div
          className="max-w-md mx-auto"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-2xl font-bold mb-4 text-gray-800">
            We can't seem to find the page you're looking for.
          </h2>
          <p className="text-lg text-gray-600 mb-6">
            But don't worry, we've got you covered. You can go back to the homepage or explore our latest posts.
          </p>
          <Link
            to="/"
            className="bg-perspective-green text-white px-6 py-3 rounded-lg hover:bg-perspective-sage transition-colors flex items-center justify-center gap-2 mx-auto"
          >
            <FaArrowLeft /> Go Back Home
          </Link>
        </motion.div>
      </section>
    </div>
  );
};

export default Error404Page;
